export const GA_TRACKING_ID = import.meta.env.VITE_GA_TRACKING_ID

const pageView = (url: string) => {
  window.gtag?.('config', GA_TRACKING_ID, {
    page_path: url
  })
}

const event = (action: string, params: Record<string, any>) => {
  window.gtag?.('event', action, params)
}

const setUserProperties = (email: string, clientName: string) => {
  window.gtag?.('set', 'user_properties', {
    user_email: email,
    client_name: clientName
  })
}

const analytics = {
  pageView,
  event,
  setUserProperties
}

export default analytics
